import moment from 'moment'
const dateTimeFormat = 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
const dateFormat = 'YYYY-MM-DD'
const timeFormat = 'HH:mm:ss'
const timeUnitsForDateTime = [
    {label:'年',value:'years'},
    {label:'月',value:'months'},
    {label:'周',value:'weeks'},
    {label:'天',value:'days'},
    {label:'小时',value:'hours'},
    {label:'分钟',value:'minutes'},
    {label:'秒',value:'seconds'}
]
const timeUnitsForDateTimeJavaTimeDuration = [
    {label:'天',value:'days'},
    {label:'小时',value:'hours'},
    {label:'分钟',value:'minutes'},
    {label:'秒',value:'seconds'}
]
const timeUnitsForDate = [
    {label:'年',value:'years'},
    {label:'月',value:'months'},
    {label:'周',value:'weeks'},
    {label:'天',value:'days'}
]
const timeUnitsForTime = [
    {label:'小时',value:'hours'},
    {label:'分钟',value:'minutes'},
    {label:'秒',value:'seconds'}
]

function parseDuration(duration, timeUnits){
    for(let i=timeUnits.length-1;i>=0;i--){
        const unit = timeUnits[i]
        const amount = duration[unit.value]()
        if(amount>0){
            const asAmount = duration['as'+unit.value.substring(0,1).toUpperCase()+unit.value.substring(1)]()
            return {
                amount: asAmount,
                unit: unit.value
            }
        }
    }
    return {
        amount: null,
        unit: 'months'
    }
}

function parseInterval (value, defaultTimeUnit, timeUnits, format) {
    if(!value){
        return {
            type: 'relative',
            range: null,
            amount: null,
            unit: defaultTimeUnit,
        }
    }else if(value.startsWith('P')){
        const duration = moment.duration(value)
        const parsedDuration = parseDuration(duration, timeUnits)
        if(parsedDuration.amount){
            return {
                type: 'relative',
                range: [
                    moment().subtract(parsedDuration.amount, parsedDuration.unit).valueOf(),
                    moment().valueOf()],
                amount: parsedDuration.amount,
                unit: parsedDuration.unit
            }
        }else{
            return {
                type: 'relative',
                range: null,
                amount: null,
                unit: defaultTimeUnit,
            }
        }
    }else{
        const range = value.split('/').map(item => moment(item, format).valueOf())
        const duration = moment.duration(moment(range[1]).diff(moment(range[0])))
        const parsedDuration = this.parseDuration(duration)
        return {
            type: 'absolute',
            range: range,
            amount: parsedDuration.amount,
            unit: parsedDuration.unit
        }
    }
}

function formatDateTime(value, format) {
    return moment(value).format(format||dateTimeFormat)
}

function formatDate(value, format) {
    return moment(value).format(format||dateFormat)
}

function formatTime(value, format) {
    return moment(value).format(format||timeFormat)
}

function javaFormatDateTime(value, javaFormat) {
    if (javaFormat) {
        return moment(value).format(toMomentFormatString(javaFormat))
    }else{
        return moment(value).format(dateTimeFormat)
    }
}

function javaFormatDate(value, javaFormat) {
    if (javaFormat) {
        return moment(value).format(toMomentFormatString(javaFormat))
    }else{
        return moment(value).format(dateFormat)
    }
}

function javaFormatTime(value, javaFormat) {
    if (javaFormat) {
        return moment(value).format(toMomentFormatString(javaFormat))
    }else{
        return moment(value).format(timeFormat)
    }
}


/**
 * The internal **Java** date formats cache.
 *
 * @property javaDateFormats
 * @type {Object}
 */
const javaDateFormats = {}

/**
 * The internal **moment.js** date formats cache.
 *
 * @property momentDateFormats
 * @type {Object}
 */
const momentDateFormats = {}

/**
 * The format pattern mapping from Java format to momentjs.
 *
 * @property javaFormatMapping
 * @type {Object}
 */
const javaFormatMapping = {
    d: 'D',
    dd: 'DD',
    y: 'YYYY',
    yy: 'YY',
    yyy: 'YYYY',
    yyyy: 'YYYY',
    u: 'YYYY',
    uu: 'YY',
    uuu: 'YYYY',
    uuuu: 'YYYY',
    a: 'a',
    A: 'A',
    M: 'M',
    MM: 'MM',
    MMM: 'MMM',
    MMMM: 'MMMM',
    h: 'h',
    hh: 'hh',
    H: 'H',
    HH: 'HH',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'SSS',
    SS: 'SSS',
    SSS: 'SSS',
    E: 'ddd',
    EE: 'ddd',
    EEE: 'ddd',
    EEEE: 'dddd',
    EEEEE: 'dddd',
    EEEEEE: 'dddd',
    D: 'DDD',
    w: 'W',
    ww: 'WW',
    z: 'ZZ',
    zzzz: 'Z',
    Z: 'ZZ',
    X: 'ZZ',
    XX: 'ZZ',
    XXX: 'Z',
}

/**
 * The format pattern mapping from Java format to moment.js.
 *
 * @property momentFormatMapping
 * @type {Object}
 */
const momentFormatMapping = {
    D: 'd',
    DD: 'dd',
    YY: 'uu',
    YYY: 'uuuu',
    YYYY: 'uuuu',
    a: 'a',
    A: 'a',
    M: 'M',
    MM: 'MM',
    MMM: 'MMM',
    MMMM: 'MMMM',
    h: 'h',
    hh: 'hh',
    H: 'H',
    HH: 'HH',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'S',
    SSS: 'S',
    ddd: 'E',
    dddd: 'EEEE',
    DDD: 'D',
    W: 'w',
    WW: 'ww',
    ZZ: 'z',
    Z: 'XXX',
    E: 'u'
}


/**
 * Translates the java date format String to a momentjs format String.
 *
 * @function translateFormat
 * @param {String}  formatString    The unmodified format string
 * @param {Object}  mapping         The date format mapping object
 * @returns {String}
 */
function translateFormat(formatString, mapping) {
    const len = formatString.length
    let i = 0
    let startIndex = -1
    let lastChar = null
    let currentChar = ""
    let resultString = ""

    for (; i < len; i++) {
        currentChar = formatString.charAt(i)

        if (lastChar === null || lastChar !== currentChar) {
            // change detected
            resultString = _appendMappedString(formatString, mapping, startIndex, i, resultString)

            startIndex = i
        }

        lastChar = currentChar
    }

    return _appendMappedString(formatString, mapping, startIndex, i, resultString)
}

/**
 * Checks if the substring is a mapped date format pattern and adds it to the result format String.
 *
 * @function _appendMappedString
 * @param {String}  formatString    The unmodified format String.
 * @param {Object}  mapping         The date format mapping Object.
 * @param {Number}  startIndex      The begin index of the continuous format characters.
 * @param {Number}  currentIndex    The last index of the continuous format characters.
 * @param {String}  resultString    The result format String.
 * @returns {String}
 * @private
 */
function _appendMappedString(formatString, mapping, startIndex, currentIndex, resultString) {
    if (startIndex !== -1) {
        let tempString = formatString.substring(startIndex, currentIndex)

        // check if the temporary string has a known mapping
        if (mapping[tempString]) {
            tempString = mapping[tempString]
        }

        resultString += tempString
    }

    return resultString
}

/**
 * Translates the momentjs format String to a java date format String.
 *
 * @function toJDFString
 * @param {String}  formatString    The format String to be translated.
 * @returns {String}
 */
function toMomentFormatString(formatString) {
    if (!javaDateFormats[formatString]) {
        let mapped = ""
        const regexp = /[^']+|('[^']*')/g
        let part = ''

        while ((part = regexp.exec(formatString))) {
            part = part[0]

            if (part.match(/'(.*?)'/)) {
                mapped += "[" + part.substring(1, part.length - 1) + "]"
            } else {
                mapped += translateFormat(part, javaFormatMapping)
            }
        }

        javaDateFormats[formatString] = mapped
    }

    return javaDateFormats[formatString]
}

/**
 * Translates the momentjs format string to a java date format string
 *
 * @function toJDFString
 * @param {String}  formatString    The format String to be translated.
 * @returns {String}
 */
function toJDFString(formatString) {
    if (!momentDateFormats[formatString]) {
        momentDateFormats[formatString] = translateFormat(formatString, momentFormatMapping);
    }

    return momentDateFormats[formatString];
}

export default {
    dateTimeFormat,
    dateFormat,
    timeFormat,
    timeUnitsForDateTime,
    timeUnitsForDateTimeJavaTimeDuration,
    timeUnitsForDate,
    timeUnitsForTime,
    parseDuration,
    parseInterval,
    parseDateInterval(value, defaultTimeUnit){
        return parseInterval(value, defaultTimeUnit||'months', timeUnitsForDate, dateFormat)
    },
    parseDateTimeInterval(value, defaultTimeUnit){
        return parseInterval(value, defaultTimeUnit||'months', timeUnitsForDateTime, dateTimeFormat)
    },
    parseTimeInterval(value, defaultTimeUnit){
        return parseInterval(value, defaultTimeUnit||'hours', timeUnitsForTime, timeFormat)
    },
    formatDateTime,
    formatDate,
    formatTime,
    javaFormatDateTime,
    javaFormatDate,
    javaFormatTime,
    toMomentFormatString,
    toJDFString
}
